/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_ActivatedInputs */

const cs_templates_activated = /** @type {(inputs: Templates_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona aktivována`)
};

const en_templates_activated = /** @type {(inputs: Templates_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template activated`)
};

/**
* | output |
* | --- |
* | "Template activated" |
*
* @param {Templates_ActivatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_activated = /** @type {((inputs?: Templates_ActivatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_ActivatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_activated(inputs)
	return cs_templates_activated(inputs)
});